export default __webpack_public_path__ + "54321e26b8bf4739a16d0adb7bc25e0c.woff2";